import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const usePropTips = async (params: object) => {
  return await GET({ url: Api.usePropTips, params, showError: false })
}
export const selectArea = async (params: object) => {
  return await POST({ url: Api.selectDestinationPoi, params, showError: false })
}
export const submit = async (data: object, bizCodeHandler, bizCodes) => {
  return await POST({
    url: Api.submit,
    data,
    showError: false,
    bizCodeHandler,
    bizCodes
  })
}
